<template>  
  <v-container grid-list-lg class="ma-0 pa-0">
    <v-layout row>
      <v-flex xs12 md4>
        <form @submit.prevent="onsubmit">
        <v-card>                    
          <v-card-text>           
           
            <template >
              <v-text-field outlined dense
              label="Username"
              v-model="fm.username"
              append-icon="person"
              type="text"
              :error="!!error.username.length"
              :error-messages="error.username"
              ></v-text-field>

              <v-text-field  outlined dense
              label="Email"
              v-model="fm.email"
              append-icon="email"
              type="email"
              :error="!!error.email.length"
              :error-messages="error.email"
              ></v-text-field>             
            </template>
            
             <v-text-field outlined dense
              label="Phone"
              v-model="fm.phone"
              append-icon="phone"
              type="text"
              :error="!!error.phone.length"
              :error-messages="error.phone"
              ></v-text-field>

            <v-text-field outlined dense
              id="password"
              label="Password"
              v-model="fm.password"
              :error="!!error.password.length"
              :error-messages="error.password"
              :append-icon="showPass ? 'visibility' : 'visibility_off'"                    
              :type="showPass ? 'text' : 'password'"
              @click:append="showPass = !showPass"
            ></v-text-field>

            <!--<v-text-field v-if="isUpdate"
              id="password"
              label="Retype Password"
              v-model="fm.retype_password"
              prepend-icon="lock"
              type="password"
              :error="!!error.retype_password.length"
              :error-messages="error.retype_password"
            ></v-text-field>-->

            <!--<v-text-field v-else
              id="password"
              label="Retype Password"
              v-model="fm.retypePassword"
              prepend-icon="lock"
              type="password"
              :error="!!error.retypePassword.length"
              :error-messages="error.retypePassword"
            ></v-text-field>-->
            
            <v-text-field outlined dense
              label="Fullname"
              v-model="fm.name"
              append-icon="person"
              type="text"
              :error="!!error.name.length"
              :error-messages="error.name"
              ></v-text-field>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
          </v-card-actions>
        </v-card>
        </form>   
      </v-flex>      
    </v-layout>
  </v-container>    
</template>

<script>
import Model from '@/app/models/Admin'
const  model = new Model();

export default {
  data : () => ({  
    fm:{username: null, email:null, phone:null, password:null, status:10, name:null,/*retype_password: null, retypePassword: null*/},
    error:{username : [], email : [], phone : [], password : [], status:[], name:[],/*retype_password:[], retypePassword:[]*/ },
    loading: false,
    isUpdate: false,
    term: null,
    mode: 0,    
    showPass : false,
  }),
  computed: {
    showAssignment(){
      return this.$route.query.id !== undefined;
    }    
  },
  mounted(){
    this.isUpdate = true;
    model.profileIndex({expand:'tinyFileBase64'}).then(data=>{
      Object.assign(this.fm, data);
    })    
  },
  methods: {
    onsubmit(){
      this.loading = true;  this.clearErrors();
      if(this.isUpdate){        
        model.update(this.fm, {id:this.fm.id}).then(res=>{this.responseSubmit(res)})
      } else {        
        model.create(this.fm).then(res=>{this.responseSubmit(res, true)})
      }
    },

    responseSubmit(res, insert=false){
      this.loading = false;
      if(res.status === 200){
        window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});            
        if(insert){
          this.isUpdate = true;
          this.$router.replace({name:'profile/form', query:{id:res.data.id}})
        } else {
          this.$router.push({name:'profile'})
        }        
      } else {
        this.validate(res.data);
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      this.error.username = this.fm.username ? [] : ['Username is required']
      this.error.email = this.fm.email ? [] : ['Email is required']
      if(!this.isUpdate){
        this.error.password = this.fm.password ? [] : ['Password is required']
      }
      //this.error.retype_password = [];
      //this.error.retypePassword  = [];      
    }
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
</style>